<template>
  <v-generic-input
    :label="label"
    :translate-text="translateText"
    :help-text="helpText"
    :id="`${givenId}`"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <v-multiselect
        :id="`${givenId}`"
        v-model="internalValue"
        :options="options"
        :multiple="true"
        :placeholder="$t(placeholder)"
        :close-on-select="false"
        :disabled="disabled"
        label="name"
        track-by="id"
      />
    </template>
  </v-generic-input>
</template>

<script>
import _GenericInput from '@/common/components/inputs/_GenericInput.vue';
import { GenericInputMixin } from '@/common/utils/mixins';
import Multiselect from 'vue-multiselect';


export default {
  name: 'MultiSelect',
  components: {
    'v-multiselect': Multiselect,
    'v-generic-input': _GenericInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  watch: {
    internalValue(v) {
      this.$emit('input', v);
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      internalValue: this.value,
      givenId: null,
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
div.multiselect__tags {
  border-width: 0;
  border-bottom-width: 1px;
  border-color: rgba(24,28,33,0.1);
  border-radius: 0;
  color: #4E5155;
  padding-left: 0.5rem;
  font-size: .894rem;
  background: rgba(24,28,33,0.015) !important;

}
</style>
